import * as React from 'react'
import { connect } from 'react-redux'
import { Form, Formik, FormikProps } from 'formik'
import { OptionsType } from 'react-select/lib/types'

import * as Yup from 'yup'
import classnames from 'classnames'

import Moment from 'react-moment'
import { Button } from 'reactstrap'
import * as CurrencyFormat from 'react-currency-format'

import { RootState } from '../../store/rootReducer'
import { Claim } from '../../lib/interfaces/Claim.interface'

import Breadcrumbs from '../Breadcrumbs.component'
import TextArea from '../../common/TextArea.component'
import ClaimsList from '../../common/ClaimsList.component'
import CustomSelect from '../../common/CustomSelect.component'
import LocationSelect from '../../common/LocationSelect.component'

import * as appActions from '../../store/app/actions'
import * as invoicesActions from '../../store/invoices/actions'
import * as accidentsActions from '../../store/accidents/actions'

const moment = require('moment')

const get = require('lodash/get')
const map = require('lodash/map')
const forEach = require('lodash/forEach')
const includes = require('lodash/includes')
const findIndex = require('lodash/findIndex')

export interface InvoiceCreationPageProps {
  openClaims?: Claim[]
  isFetchingOpenClaims: boolean
  createInvoice: (claimIds: number[]) => void
  fetchOpenClaims: (next?: () => void) => void
}

export interface InvoiceCreationPageState {
  selectedClaimsIndexes: number[]
}

class InvoiceCreationPage extends React.PureComponent<InvoiceCreationPageProps, InvoiceCreationPageState> {
  constructor(props) {
    super(props)

    this.state = {
      selectedClaimsIndexes: []
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount() {
    const { fetchOpenClaims } = this.props
    fetchOpenClaims()
  }

  componentDidUpdate(prevProps, prevState) {
    const { openClaims, isFetchingOpenClaims } = this.props

    if (prevProps.isFetchingOpenClaims && !isFetchingOpenClaims) {
      this.setState({ selectedClaimsIndexes: this.allClaimsIndexes })
    }
  }

  get allClaimsIndexes() {
    const { openClaims } = this.props
    return map(openClaims, (claim, index) => index)
  }

  onSubmit() {
    const { selectedClaimsIndexes } = this.state
    const { openClaims, createInvoice } = this.props

    const claimIds = map(selectedClaimsIndexes, index => get(openClaims, `[${index}].id`))
    createInvoice(claimIds)
  }

  renderCurrencyValue(value) {
    return (
      <CurrencyFormat
        prefix="$"
        value={value}
        decimalScale={2}
        displayType="text"
        thousandSeparator={true}
        fixedDecimalScale={true}
      />
    )
  }

  getExpirationStatusText(claim) {
    const now = moment()
    const dueDate = moment(claim.lossDate).add(60, 'day')

    const duration = moment.duration(dueDate.diff(now))
    const daysDiff = duration.asDays()

    let expirationText
    if (daysDiff <= -1) {
      const expiredDays = Math.floor(Math.abs(daysDiff))
      expirationText = `Expired ${expiredDays} days ago`
    }
    else if (daysDiff >= -1 && daysDiff <= 1) {
      expirationText = 'Expires today'
    }
    else {
      expirationText = `Expires in ${Math.floor(daysDiff)} days`
    }

    return expirationText
  }

  renderTotalCost() {
    const { openClaims } = this.props
    const { selectedClaimsIndexes } = this.state

    let totalCost = 0

    forEach(selectedClaimsIndexes, index => {
      const claimDamage = get(openClaims, `[${index}].damage`, 0)
      totalCost += claimDamage
    })

    return this.renderCurrencyValue(totalCost)
  }

  onChangeSelectedIndex(index) {
    const { selectedClaimsIndexes } = this.state
    
    const adding = !includes(selectedClaimsIndexes, index)

    const newSelectedClaimsIndexes = [ ...selectedClaimsIndexes ]

    if (adding) {
      newSelectedClaimsIndexes.push(index)
    }
    else {
      const oldIndex = findIndex(selectedClaimsIndexes, i => i === index)
      if (oldIndex >= 0) {
        newSelectedClaimsIndexes.splice(oldIndex, 1)
      }
    }

    this.setState({ selectedClaimsIndexes: newSelectedClaimsIndexes })
  }

  render() {
    const { selectedClaimsIndexes } = this.state
    const { isFetchingOpenClaims, openClaims } = this.props

    return (
      <div>
        <Breadcrumbs breadcrumbs={[
          { name: 'Invoices', link: '/invoices' },
          { name: 'Create new invoice', active: true }
        ]} />

        {isFetchingOpenClaims
          ? <div className="p-3">Loading...</div>
          : (
            <div className="page addinvoice-page container-fluid">
              <section>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <h5 className="title mb-0">Open Claims</h5>

                  <div className="d-flex">
                    <Button
                      color="dark"
                      className="ggbutton"
                      onClick={() => this.setState({ selectedClaimsIndexes: [] })}
                    >
                      Uncheck all
                    </Button>

                    <Button
                      color="primary"
                      className="ggbutton ml-2"
                      onClick={() => this.setState({ selectedClaimsIndexes: this.allClaimsIndexes })}
                    >
                      Check all
                    </Button>

                    <Button
                      color="primary"
                      onClick={this.onSubmit}
                      className="ggbutton ml-4"
                      disabled={selectedClaimsIndexes.length === 0}
                    >
                      Save
                    </Button>

                  </div>
                </div>

                <div className="row no-gutters mt-2">
                  <div className="ggcard col-12 p-4">
                    <div className="row no-gutters">
                      <div className="col-4">
                        <div className="d-flex align-items-center justify-content-center">
                          <p style={{ marginBottom: 0 }}>
                            <b className="text-uppercase">Total claims: {get(openClaims, 'length', 0)}</b>
                          </p>
                        </div>
                      </div>

                      <div className="col-4">
                        <div className="d-flex align-items-center justify-content-center">
                          <p style={{ marginBottom: 0 }}>
                            <b className="text-uppercase">Selected claims: {get(selectedClaimsIndexes, 'length', 0)}</b>
                          </p>
                        </div>
                      </div>

                      <div className="col-4">
                        <div className="d-flex align-items-center justify-content-center">
                          <p style={{ marginBottom: 0 }}>
                            <b className="text-uppercase">Total cost: {this.renderTotalCost()}</b>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="w-100 mt-4">
                    <ClaimsList
                      selectable
                      viewMode="table"
                      className="mt-2"
                      claims={openClaims}
                      selectedIds={selectedClaimsIndexes}
                      emptyMessage="There are no claims attached to this invoice."
                      onRowClick={(claim, index) => this.onChangeSelectedIndex(index)}
                      columns={[
                        'erac',
                        'location',
                        'vin',
                        'vehicle',
                        'driver',
                        'status',
                        'claim-type',
                        'loss-date',
                        'cost'
                      ]}
                    />
                  </div>
                </div>
              </section>
            </div>
          )
        }
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  openClaims: state.accidents.openClaims,
  isFetchingOpenClaims: state.accidents.isFetchingOpenClaims
})

const mapDispatchToProps = (dispatch) => ({
  createInvoice: (claimIds: number[]) => dispatch(invoicesActions.createInvoice(claimIds)),
  fetchOpenClaims: (next?: () => void) => dispatch(accidentsActions.fetchOpenClaims(next))
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceCreationPage)



// WEBPACK FOOTER //
// ./src/routes/invoices/InvoiceCreation.page.tsx